/**
 * A simple wrapper class for a value.
 * Useful for passing a value to a function and having the function modify the value. Or managing state in react callbacks.
 * Example usage:
 * const wrapper = new Wrapper(0);
 * wrapper.value = 1;
 * console.log(wrapper.value); // 1
 */
export default class Wrapper {
	constructor(value) {
		this.value = value;
	}
}